import { useMemo } from 'react';

import { useAtomValue } from 'jotai';

import { parametersMapAtom, layoutCustomizationsAtom } from '@store';

export function useTableParameters(nodeId: string) {
    const parametersMap = useAtomValue(parametersMapAtom);
    const layoutCustomizations = useAtomValue(layoutCustomizationsAtom);
    const tableCustomizations = useMemo(
        () => layoutCustomizations.filter((customization) => customization.parentUiNodeId === nodeId),
        [layoutCustomizations, nodeId],
    );
    return useMemo(
        () => tableCustomizations.map((customization) => parametersMap[customization.childUiNodeId]),
        [tableCustomizations, parametersMap],
    );
}
